import React, { forwardRef } from 'react';
import { mergeClassAttributes } from '../../helpers/classes';

export type BoxProps = {
  cn?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ cn, ...props }, ref) => {
    const mergedClassName = mergeClassAttributes(props, cn);
    return <div {...props} className={mergedClassName} ref={ref} />;
  },
);

Box.displayName = 'Box';

export const Flex = forwardRef<HTMLDivElement, BoxProps>(
  ({ cn, ...props }, ref) => {
    const mergedClassName = mergeClassAttributes(props, ['flex', cn || '']);
    return <div {...props} className={mergedClassName} ref={ref} />;
  },
);

Flex.displayName = 'Flex';
